import CustomerStories from "./customer-stories/index.js";
export default {
    CustomerStories
};
